import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-hot-toast';

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  //const { signOut, user } = useAuth();
  const { signOut } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  //const isRestrictedUser = user?.email === 'contact@cgci-paris.com';
  
  const isActive = (path) => {
    // Cas spécial pour le tableau de bord - actif uniquement sur la page exacte
    if (path === '/admin') {
      return location.pathname === '/admin';
    }
    // Pour les autres pages, actif si le chemin commence par le path
    return location.pathname.startsWith(path);
  };
  
  // Définir les éléments de menu en fonction du type d'utilisateur
  const getMenuItems = () => {
    const baseMenuItems = [
      { path: '/admin', label: 'Tableau de bord', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
      { path: '/admin/users', label: 'Carnet d\'adresses', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
      { path: '/admin/shipments', label: 'Expéditions', icon: 'M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4' },
      { path: '/admin/fedex-tracking', label: 'Tracking FedEx', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
      { path: '/admin/services', label: 'Services', icon: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
      { path: '/admin/categories', label: 'Catégories', icon: 'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z' },
      { path: '/admin/consular-acts', label: 'Actes consulaires', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
      { path: '/admin/analytics', label: 'Statistiques', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' }
    ];
    
    // Ajouter l'élément Paiements seulement si l'utilisateur n'est pas restreint
    /*if (!isRestrictedUser) {
      // Insérer l'élément Paiements après Utilisateurs (index 1)
      baseMenuItems.splice(2, 0, { 
        path: '/admin/payments', 
        label: 'Paiements', 
        icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z' 
      });
    }*/
    
    return baseMenuItems;
  };
  
  const menuItems = getMenuItems();
  
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  const handleLogout = async () => {
    try {
      console.log('Dashboard: Tentative de déconnexion');
      const result = await signOut();
      if (result.success) {
        console.log('Dashboard: Déconnexion réussie, redirection vers la page de connexion');
        navigate('/admin/login');
      } else {
        console.error('Dashboard: Échec de la déconnexion:', result.error);
        toast.error(result.error || 'Échec de la déconnexion');
      }
    } catch (error) {
      console.error('Dashboard: Erreur lors de la déconnexion:', error);
      toast.error('Une erreur est survenue lors de la déconnexion');
    }
  };
  
  // Log pour débogage
  useEffect(() => {
    console.log('Dashboard: Rendu du dashboard, chemin actuel:', location.pathname);
  }, [location.pathname]);
  
  return (
    <div className="flex h-screen w-screen bg-gray-100 overflow-hidden">
      {/* Sidebar - Desktop */}
      <div className="hidden md:flex fixed top-0 left-0 h-screen bg-white shadow-md z-10" style={{ width: '280px' }}>
        <div className="flex flex-col h-full w-full">
          <div className="flex items-center justify-center py-6">
            <img src="/assets/img/logo-cgciparis.png" alt="Logo" style={{width: '200px', height: 'auto'}} />
          </div>
          <nav className="flex-1 overflow-y-auto scrollbar-hide">
            <ul style={{listStyle: 'none', padding: 0, margin: 0}} className="py-4">
              {menuItems.map((item) => (
                <li key={item.path} style={{listStyle: 'none', padding: '8px 16px', margin: 0}}>
                  <Link 
                    to={item.path} 
                    className={`flex items-center px-4 py-3 text-sm rounded-lg transition-colors ${isActive(item.path) 
                      ? 'bg-primary text-white shadow-md hover:text-white' 
                      : 'text-gray-700 hover:bg-gray-100'}`}
                  >
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      className="h-5 w-5 flex-shrink-0" 
                      style={{marginRight: '16px'}}
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                    </svg>
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      {/* Mobile Menu Button */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="flex items-center justify-between p-4">
          <div className="flex items-center">
            <button 
              onClick={toggleMobileMenu} 
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 focus:outline-none"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-6 w-6" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <img src="/assets/img/logo-cgciparis.png" alt="Logo" style={{width: '100px', height: 'auto'}} className="ml-2" />
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={handleLogout}
              className="text-orange-600 hover:text-orange-800 p-1"
              aria-label="Déconnexion"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
            <Link to="/" className="text-secondary hover:underline">
              Retour au site
            </Link>
          </div>
        </div>
      </div>
      
      {/* Mobile Sidebar */}
      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 z-40 bg-black bg-opacity-50" onClick={toggleMobileMenu}>
          <div className="fixed inset-y-0 left-0 bg-white shadow-lg" style={{ width: '280px' }} onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-center py-6 bg-secondary">
              <img src="/assets/img/logo-cgciparis.png" alt="Logo" style={{width: '100px', height: 'auto'}} />
            </div>
            <div className="p-4 bg-secondary text-white">
              <h2 className="text-xl font-semibold text-center">Administration</h2>
            </div>
            <nav className="overflow-y-auto">
              <ul style={{listStyle: 'none', padding: 0, margin: 0}} className="py-4">
                {menuItems.map((item) => (
                  <li key={item.path} style={{listStyle: 'none', padding: '8px 16px', margin: 0}}>
                    <Link 
                      to={item.path} 
                      className={`flex items-center px-4 py-3 text-sm rounded-lg transition-colors ${isActive(item.path) 
                        ? 'bg-primary text-white shadow-md hover:text-white' 
                        : 'text-gray-700 hover:bg-gray-100'}`}
                      onClick={toggleMobileMenu}
                    >
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        className="h-5 w-5 flex-shrink-0" 
                        style={{marginRight: '16px'}}
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                      </svg>
                      <span>{item.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      )}
      
      {/* Main Content */}
      <div className="flex-1 w-full h-screen overflow-y-auto md:ml-[280px] md:pt-0 pt-16">
        <header className="bg-white shadow-sm hidden md:block">
          <div className="px-6 py-4 flex justify-between items-center">
            <h1 className="text-xl font-semibold text-gray-900">Panneau d&apos;administration</h1>
            <div className="flex items-center space-x-4">
              <button
                onClick={handleLogout}
                className="text-orange-600 hover:text-orange-800 flex items-center transition-colors duration-200"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Déconnexion
              </button>
              <Link to="/" className="text-secondary hover:underline flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Retour au site
              </Link>
            </div>
          </div>
        </header>

        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
